import { defineStore } from 'pinia'
import { getCategory, getSubCategoryByCategory, getCategoryDetailsById } from '@/services/categoryService'
import { getContentPage } from '@/services/contentService'
import { getProjectOngoingList, getProjectExperienceList, getProjectsByCategoryId, getProjectDetailsBySlug, getGalleryByProjectId } from '@/services/projectService'

export const useProjectStore = defineStore('project', {
  state: () => ({
    project: {},
    projects: [],
    gallerys: [],
    details: {},
    categories: [],
    loading: false,
    error: null
  }),

  actions: {
    async fetchProjectOngoingPage(categoryId = null) {
      console.log(categoryId)
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const projectContent = await getContentPage('Projects', 'Projects')
        var projectList;
        if( categoryId === null || categoryId === 'static-id' )
        {
          projectList =  await getProjectOngoingList('Ongoing,Planning', 1, 50)
        }
        else
        {
          projectList = await getProjectsByCategoryId(categoryId, 'Ongoing,Planning', 1, 50)
        }
        
        const categoryList = await getCategory()
        
        const mapCategoryList = [
          {
            parentId: null,
            _id: 'static-id',
            name: 'All',
            slug: 'all',
            descriptions: null,
            id: 'static-id',
            subCategories: []
          },
          ...(await Promise.all(
              categoryList.map(async item => ({
                ...item,
                subCategories: await getSubCategoryByCategory(item.id)
              }))
            ))
        ]

        const mapProjectList = await Promise.all(
          projectList?.docs.map(item => ({
            ...item,
            image: item.coverBanner
              ? baseUploadURL + item.coverBanner.uploadFile
              : null,
            thumbs: item.thumbnails
              ? baseUploadURL + item.thumbnails.uploadFile
              : null,

            categoryId: {
              ...item.categoryId,

              parentId:
                item?.categoryId?.parentId !== null
                  ? getCategoryDetailsById(item.categoryId.parentId)
                  : null
            }
          }))
        )

        projectList.docs = mapProjectList
        
        this.project = projectContent.length > 0 ? projectContent[0] : null
        this.categories = mapCategoryList

        this.projects = projectList
        console.log(this.project)
        console.log(this.categories)
        console.log(this.projects)
      } catch (err) {
        console.log(err)
        this.error = err.message
      } finally {
        this.loading = false
      }
    },
    async fetchProjectExperiencePage(categoryId = null) {
      console.log(categoryId)
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const projectContent = await getContentPage('Projects', 'Projects')
        var projectList;
        if( categoryId === null || categoryId === 'static-id' )
        {
          projectList =  await getProjectExperienceList('Completed', 1, 50)
        }
        else
        {
          projectList = await getProjectsByCategoryId(categoryId, 'Completed', 1, 50)
        }
        
        const categoryList = await getCategory()
        
        const mapCategoryList = [
          {
            parentId: null,
            _id: 'static-id',
            name: 'All',
            slug: 'all',
            descriptions: null,
            id: 'static-id',
            subCategories: []
          },
          ...(await Promise.all(
              categoryList.map(async item => ({
                ...item,
                subCategories: await getSubCategoryByCategory(item.id)
              }))
            ))
        ]

        const mapProjectList = await Promise.all(
          projectList?.docs.map(item => ({
            ...item,
            image: item.coverBanner
              ? baseUploadURL + item.coverBanner.uploadFile
              : null,
            thumbs: item.thumbnails
              ? baseUploadURL + item.thumbnails.uploadFile
              : null,

            categoryId: {
              ...item.categoryId,

              parentId:
                item?.categoryId?.parentId !== null
                  ? getCategoryDetailsById(item.categoryId.parentId)
                  : null
            }
          }))
        )

        projectList.docs = mapProjectList
        
        this.project = projectContent.length > 0 ? projectContent[0] : null
        this.categories = mapCategoryList

        this.projects = projectList
        console.log(this.project)
        console.log(this.categories)
        console.log(this.projects)
      } catch (err) {
        console.log(err)
        this.error = err.message
      } finally {
        this.loading = false
      }
    },
    async fetchProjectDetailsBySlug(slug) {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const detailsContent = await getProjectDetailsBySlug(slug)
        const projectListByCategoryId = await getProjectsByCategoryId(detailsContent?.categoryId._id, 1, 10)
        const galleryProjects = await getGalleryByProjectId(detailsContent?._id, 1, 100)
        
        // detailsContent.image = detailsContent.thumbnails
        //   ? baseUploadURL + detailsContent.thumbnails.uploadFile
        //   : null

        // detailsContent.categoryId.parentId =
        //   detailsContent?.categoryId?.parentId
        //     ? await getCategoryDetailsById(detailsContent.categoryId.parentId)
        //     : null
        
        const [parentCategory] = await Promise.all([
          detailsContent?.categoryId?.parentId
            ? getCategoryDetailsById(detailsContent.categoryId.parentId)
            : Promise.resolve(null)
        ])

        detailsContent.image = detailsContent.thumbnails
          ? baseUploadURL + detailsContent.thumbnails.uploadFile
          : null

        detailsContent.banner = detailsContent.coverBanner
          ? baseUploadURL + detailsContent.coverBanner.uploadFile
          : null

        detailsContent.categoryId.parentId = parentCategory
        
        console.log(detailsContent)
        console.log(projectListByCategoryId)
        console.log(galleryProjects)
        
        const mapProjectList = await Promise.all(
          projectListByCategoryId.docs.map(async item => ({
            ...item,
            image: item.coverBanner
              ? baseUploadURL + item.coverBanner.uploadFile
              : null,
            thumbs: item.thumbnails
              ? baseUploadURL + item.thumbnails.uploadFile
              : null,

            categoryId: {
              ...item.categoryId,

              parentId:
                item?.categoryId?.parentId !== null
                  ? await getCategoryDetailsById(item?.categoryId?.parentId)
                  : null
            }
          }))
        )

        const mapGalleryProjects = await Promise.all(
          galleryProjects.docs.map(async item => ({
            ...item,
            banner: baseUploadURL + item.uploadFile,
          }))
        )

        this.details = detailsContent
        this.projects = mapProjectList
        this.gallerys = mapGalleryProjects;
        console.log(this.details)
        console.log(this.projects)
        console.log(this.gallerys)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    },
  }
})